import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const empty = { name: "", email: "", password: "", company: "" };

export default function Register() {
  const { user, register } = useAuth();
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && user.email) return <Navigate to="/area-riservata" replace />;

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) {
      setError("La password deve avere almeno 8 caratteri");
      return;
    }
    setLoading(true);
    setError("");
    const res = await register(form);
    setLoading(false);
    if (!res.ok) {
      setError(res.error || "Errore di registrazione");
      toast.error("Registrazione fallita", { description: res.error });
    } else {
      toast.success("Account creato", { description: "Benvenuto in XL Brokers" });
    }
  };

  return (
    <div data-testid="page-register" className="min-h-screen pt-32 pb-20">
      <div className="container-x max-w-2xl">
        <span className="overline">Area Riservata</span>
        <h1 className="mt-3 font-display text-5xl sm:text-6xl leading-tight">Crea il tuo account.</h1>
        <p className="mt-4 lead">
          Accedi al tuo dossier assicurativo personalizzato in pochi secondi.
        </p>

        <form onSubmit={submit} className="mt-12 space-y-8" data-testid="register-form">
          <div>
            <label htmlFor="reg-name" className="field-label">Nome e cognome</label>
            <input id="reg-name" required minLength={2} data-testid="register-input-name"
              value={form.name} onChange={(e) => update("name", e.target.value)} className="field-input" />
          </div>
          <div>
            <label htmlFor="reg-company" className="field-label">Azienda (opzionale)</label>
            <input id="reg-company" data-testid="register-input-company"
              value={form.company} onChange={(e) => update("company", e.target.value)} className="field-input" />
          </div>
          <div>
            <label htmlFor="reg-email" className="field-label">Email</label>
            <input id="reg-email" type="email" required data-testid="register-input-email"
              value={form.email} onChange={(e) => update("email", e.target.value)} className="field-input" />
          </div>
          <div>
            <label htmlFor="reg-password" className="field-label">Password (min. 8 caratteri)</label>
            <input id="reg-password" type="password" required minLength={8} data-testid="register-input-password"
              value={form.password} onChange={(e) => update("password", e.target.value)} className="field-input" />
          </div>

          {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}

          <button type="submit" disabled={loading} data-testid="register-submit" className="btn-primary w-full">
            {loading ? "Creazione in corso..." : "Crea account"}
          </button>

          <p className="text-sm text-muted-foreground">
            Hai già un account?{" "}
            <Link to="/accedi" className="underline-link text-foreground" data-testid="link-login">
              Accedi
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
